import GradientContainer from "@app/components/gradient/gradient-container";
import Icon from "@mdi/react";
import { mdiAccountOutline } from "@mdi/js";
import { useThemeContext } from "@app/contexts/theme-context";

const EmployeesSectionMidContent = () => {
  const { isMobile } = useThemeContext();
  return (
    <div className="flex flex-col-reverse md:grid md:grid-cols-12 w-full">
      <div className="md:col-span-5 mt-8 md:mt-0">
        <div
          className="min-h-[512px] h-full w-full bg-cover bg-center bg-no-repeat rounded-xl md:rounded-tl-none 
            md:rounded-bl-none md:rounded-tr-xl md:rounder-br-xl"
          style={{
            backgroundImage:
              "url('/images/acquisitions/employees-section-1.png')",
          }}
        />
      </div>
      {!isMobile && <div className="col-span-1" />}
      <div className="md:col-span-5 flex flex-row items-center">
        <div className="md:w-[560px] flex flex-col space-y-4">
          <GradientContainer overrideClassName="p-3 mb-2 w-12 rounded-full shadow-outer-secondary">
            <Icon size={1} path={mdiAccountOutline} />
          </GradientContainer>
          <span className="mobile-h4 md:h5 lg:h4">Customer Advantages</span>
          <span className="text-body-lg">
            Our platform is guaranteed to deliver the innovation and value your
            customers deserve. We pride ourselves in taking care of your clients
            by ensuring their immediate and long-term service needs are met with
            the utmost attention to detail.
          </span>
        </div>
      </div>
    </div>
  );
};

export default EmployeesSectionMidContent;
